import { render, staticRenderFns } from "./StandardBadgeMini.component.vue?vue&type=template&id=54904ec1&"
var script = {}
import style0 from "./StandardBadgeMini.component.vue?vue&type=style&index=0&id=54904ec1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports